import axios from "axios";

export const client = axios.create({
  // baseURL: "https://af68-79-41-17-239.ngrok.io",
  baseURL: "https://api.semplisio.it/",
  //baseURL: "https://testapi.semplisio.it/",
  //baseURL: "http://127.0.0.1:8100/"
});
